/* Quick view pop-up for the home page "Just landed" frames. Uses the storefront /products/<handle>.js data and /cart/add.js. */
(function () {
  var root = document.querySelector('.rad-arrivals');
  var qv = document.querySelector('.rad-qv');
  if (!root || !qv) return;
  var $ = function (s) { return qv.querySelector(s); };
  var data = null, current = null, curCode = root.getAttribute('data-currency') || 'AUD';
  function money(c) { return '$' + (c / 100).toFixed(2) + ' ' + curCode; }
  function img(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function strip(h) { var d = document.createElement('div'); d.innerHTML = h || ''; var t = (d.textContent || '').replace(/\s+/g, ' ').trim(); return t.length > 260 ? t.slice(0, 257) + '...' : t; }
  function setImage(src) {
    $('[data-main]').src = img(src, 900);
    qv.querySelectorAll('[data-thumbs] button').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-src') === src); });
  }
  function showVariant(v) {
    current = v;
    $('[data-price]').innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
    var add = $('[data-add]');
    add.disabled = !v.available; add.textContent = v.available ? 'Add to cart' : 'Sold out';
    var fi = v.featured_image && v.featured_image.src;
    if (fi) setImage(fi);
    $('[data-msg]').textContent = ''; $('[data-msg]').className = 'rad-qv__msg';
  }
  function open(p, handle) {
    data = p;
    $('[data-title]').textContent = p.title;
    $('[data-desc]').textContent = strip(p.description);
    $('[data-more]').href = '/products/' + handle;
    var sel = $('[data-select]'), lbl = $('[data-lbl]');
    sel.innerHTML = '';
    var single = p.variants.length === 1;
    sel.style.display = lbl.style.display = single ? 'none' : '';
    lbl.textContent = p.options && p.options[0] ? (p.options[0].name || p.options[0]) : 'Option';
    var first = null;
    p.variants.forEach(function (v) {
      var o = document.createElement('option'); o.value = v.id; o.textContent = v.title + (v.available ? '' : ' - sold out'); o.disabled = !v.available;
      sel.appendChild(o); if (!first && v.available) first = v;
    });
    first = first || p.variants[0]; sel.value = first.id;
    var th = $('[data-thumbs]'); th.innerHTML = '';
    if ((p.images || []).length > 1) {
      p.images.forEach(function (src) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-src', src);
        b.innerHTML = '<img alt="" src="' + img(src, 120) + '">';
        b.addEventListener('click', function () { setImage(src); });
        th.appendChild(b);
      });
    }
    setImage((first.featured_image && first.featured_image.src) || p.images[0]);
    showVariant(first);
    qv.hidden = false; document.documentElement.style.overflow = 'hidden';
    $('.rad-qv__close').focus();
  }
  function close() { qv.hidden = true; document.documentElement.style.overflow = ''; }
  qv.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qv.hidden) close(); });
  $('[data-select]').addEventListener('change', function () {
    var id = +this.value; data.variants.forEach(function (v) { if (v.id === id) showVariant(v); });
  });
  $('[data-add]').addEventListener('click', function () {
    if (!current) return; var btn = this, msg = $('[data-msg]'); btn.disabled = true; msg.className = 'rad-qv__msg'; msg.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { msg.innerHTML = 'Added to your cart. <a href="/cart" style="color:inherit;text-decoration:underline">View cart</a>'; btn.disabled = false; })
      .catch(function () { msg.className = 'rad-qv__msg is-err'; msg.textContent = 'Sorry, that could not be added. Please try again.'; btn.disabled = false; });
  });
  root.querySelectorAll('.rad-frame').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      var h = a.getAttribute('data-handle');
      fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) { open(p, h); }).catch(function () { window.location = a.href; });
    });
  });
})();